// Generated types for UpdatesSummaryTask
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { StepTaskReadAPI, StepTaskWriteAPI } from '../../llm_task/types/steptask';
import { StepTaskReadAPISchemaObject, StepTaskWriteAPISchemaObject } from '../../llm_task/types/steptask';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface UpdatesSummaryTaskReadAPI extends StepTaskReadAPI {
}

export interface UpdatesSummaryTaskWriteAPI extends StepTaskWriteAPI {
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const UpdatesSummaryTaskReadAPISchema: z.ZodType<UpdatesSummaryTaskReadAPI> = StepTaskReadAPISchemaObject.extend({}).passthrough();

export const UpdatesSummaryTaskWriteAPISchema: z.ZodType<UpdatesSummaryTaskWriteAPI> = StepTaskWriteAPISchemaObject.extend({}).passthrough();
